import React from 'react';
import { componentService } from '@core/js/services/component.service';

export const Balance = React.lazy(() => import(/* webpackChunkName: "user-balance" */ '@core/js/components/main/Balance/Balance'));

import('@core/js/components/main/Balance/index').then(() => {
    componentService.registerWebContentComponents({
        CasinoInPlayBalance: () => <Balance type="balance_calc" args="casino_in_play_balance" />,
        SportsbookOpenBetsBalance: () => <Balance type="balance_calc" args="sportsbook_open_bets_balance" />,
        SportsbookGamingBalance: () => <Balance type="balance_calc" args="sportsbook_gaming_balance" />,
        CasinoGamingInplayBalance: () => <Balance type="balance_calc" args="casino_gaming_inplay_balance" />,
        SportsbookGamingInplayBalance: () => <Balance type="balance_calc" args="sportsbook_gaming_inplay_balance" />,
        SportsbookInPlayBalance: () => <Balance type="balance_calc" args="sportsbook_in_play_balance" />
    });
});
